import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpBaseService } from './http-base.service';
import { CompanyCreateDto, CompanyDetailDto, CompanyListDto, CompanyUpdateDto } from '../dtos/company.types';

@Injectable({
    providedIn: 'root'
})
export class CompanyService extends HttpBaseService {
    private readonly baseEndpoint = 'api/Companies';

    /**
     * Get all companies
     */
    getAllCompanies(): Observable<CompanyListDto[]> {
        return this.get<CompanyListDto[]>(this.baseEndpoint);
    }

    /**
     * Get company by ID
     */
    getCompanyById(companyId: string): Observable<CompanyDetailDto> {
        return this.get<CompanyDetailDto>(`${this.baseEndpoint}/${companyId}`);
    }

    /**
     * Get company for update
     */
    getCompanyForUpdate(companyId: string): Observable<CompanyUpdateDto> {
        return this.get<CompanyUpdateDto>(`${this.baseEndpoint}/${companyId}/update`);
    }

    /**
     * Create a new company
     * @returns Observable containing the created company's ID
     */
    createCompany(company: CompanyCreateDto): Observable<{ id: string }> {
        return this.post<{ id: string }>(this.baseEndpoint, company);
    }

    /**
     * Update an existing company
     */
    updateCompany(company: CompanyUpdateDto): Observable<void> {
        return this.put<void>(this.baseEndpoint, company);
    }

    /**
     * Delete a company
     */
    deleteCompany(companyId: string): Observable<void> {
        return this.delete<void>(`${this.baseEndpoint}/${companyId}`);
    }
}